import type { Good } from "@/entities/good";

export type ContentTab = "card" | "images" | "video";

/** UI-тип мастера ("photo"/"card"/"video") → вкладка списка ("images"/"card"/"video"). */
export function wizardContentTypeToTab(
  contentType: "photo" | "card" | "video" | undefined | null,
): ContentTab | null {
  if (contentType === "photo") return "images";
  if (contentType === "video") return "video";
  if (contentType === "card") return "card";
  return null;
}

/** Вкладка списка контента, к которой относится товар (Карточки / Фото / Видео). */
export function resolveGoodContentTab(good: Good): ContentTab {
  // Пока идёт генерация, у черновика может не быть версии (бэкенд сохраняет её только
  // по завершении), а `good.contentType` не персистится. Поэтому источник истины —
  // `generationContext.contentType`, записанный при старте джобы.
  if (good.generating) {
    const fromContext = wizardContentTypeToTab(good.generationContext?.contentType);
    if (fromContext) return fromContext;
  }

  const activeVersion = good.versions?.find((version) => version.isActive) ?? good.versions?.[0];
  const ct = activeVersion?.contentType;
  if (ct === "images" || ct === "photo") return "images";
  if (ct === "video") return "video";
  if (ct === "card") return "card";
  if (good.versions?.some((version) => version.contentType === "images" || version.contentType === "photo")) {
    return "images";
  }
  if (good.versions?.some((version) => version.contentType === "video")) return "video";
  return good.contentType === "images" ? "images" : good.contentType === "video" ? "video" : "card";
}
